// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker-presets {
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  color: var(--g-color-text-secondary);
  background-color: var(--g-color-base-generic);
}
.dl-datepicker_mobile .dl-datepicker-presets {
  justify-content: center;
}
.dl-datepicker-presets__item {
  margin-left: 16px;
  cursor: pointer;
}
.dl-datepicker_desktop .dl-datepicker-presets__item:hover {
  color: var(--g-color-text-complementary);
}
.dl-datepicker_mobile .dl-datepicker-presets__item:first-child {
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/Presets/Presets.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,6CAAA;AACJ;AACI;EACI,uBAAA;AACR;AAEI;EACI,iBAAA;EACA,eAAA;AAAR;AAEQ;EACI,wCAAA;AAAZ;AAGQ;EACI,cAAA;AADZ","sourcesContent":[".dl-datepicker-presets {\n  flex: 0 0 40px;\n  display: flex;\n  align-items: center;\n  color: var(--g-color-text-secondary);\n  background-color: var(--g-color-base-generic);\n}\n.dl-datepicker_mobile .dl-datepicker-presets {\n  justify-content: center;\n}\n.dl-datepicker-presets__item {\n  margin-left: 16px;\n  cursor: pointer;\n}\n.dl-datepicker_desktop .dl-datepicker-presets__item:hover {\n  color: var(--g-color-text-complementary);\n}\n.dl-datepicker_mobile .dl-datepicker-presets__item:first-child {\n  margin-left: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
